import React from 'react'

import { FontSize, FontWeight, TextAlign, Text, Color } from '@gousto-internal/citrus-react'

type AccordionTableCellProps = { children: string; size: 'large' | 'small' }

export const AccordionTableCell = ({ children, size }: AccordionTableCellProps) => {
  const textProperties =
    size === 'large'
      ? { size: 3 as FontSize, fontWeight: FontWeight.Bold }
      : { size: 0 as FontSize, color: Color.NeutralGrey_600 }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Text textAlign={TextAlign.Right} {...textProperties}>
      {children}
    </Text>
  )
}
